module.exports = __webpack_public_path__ + "static/media/决策云.eb41fe7.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mov/决策云.mp4
// module id = DCx+
// module chunks = 1